module.exports = __webpack_public_path__ + "static/media/Montserrat-ExtraLight.9ad37942.ttf";